/**
 *
 * Vendor Scripts included via NPM
 *
 * Usage:
 * 1) npm install vendor_package --save-dev
 * 2) Import path to unminified JS file in node_modules
 * **Remember import path starts from assets/js directory
 *
 */

/**
 *
 *
 */
import './global/base';
import './components/scale';
import './modules/video-plays';
